/**
 * Change-signature gate of the dashboard record_list widget.
 *
 * A `live` re-poll first fetches only a cheap signature (ids + timestamps) and
 * skips the full fetch when it matches the last full fetch. That shortcut is
 * only valid when the request has the SAME shape (fields + variables) as the
 * fetch the signature was taken from. Example: the first fetch runs before the
 * object template's attribute schema has loaded, so it does not select `value`;
 * when the schema arrives the rows' ids and timestamps are unchanged, but the
 * attribute values still have to be fetched.
 */

/** A stable key for the fetch shape (record type, template, paging, order, filter, value keys). */
export const recordListFetchShape = (parts: unknown[]): string => JSON.stringify(parts);

/**
 * True when a live re-poll may use the signature probe instead of a full fetch:
 * the widget is live, a signature exists, and it was taken for this fetch shape.
 */
export const canUseSignatureProbe = ({
    live,
    signature,
    signatureShape,
    fetchShape,
}: {
    live: boolean;
    signature: string | undefined;
    signatureShape: string | undefined;
    fetchShape: string;
}): boolean => live && signature !== undefined && signatureShape === fetchShape;
